import { createClient } from "@sanity/client";
import createImageUrlBuilder from "@sanity/image-url";

export const sanityConfigured = Boolean(process.env.REACT_APP_SANITY_PROJECT_ID);

export const sanityClient = sanityConfigured
  ? createClient({
      projectId: process.env.REACT_APP_SANITY_PROJECT_ID,
      dataset: process.env.REACT_APP_SANITY_DATASET || "production",
      apiVersion: process.env.REACT_APP_SANITY_API_VERSION || "2024-10-01",
      useCdn: true,
      perspective: "published",
    })
  : null;

const builder = sanityClient ? createImageUrlBuilder(sanityClient) : null;

export const urlFor = (source) => {
  if (!builder || !source) return null;
  return builder.image(source);
};

// convenience: get a direct image URL string with default sizing
export const imgSrc = (source, width = 1200) => {
  const u = urlFor(source);
  return u ? u.width(width).auto("format").fit("max").url() : null;
};
